import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, Skeleton } from "@mantine/core";
import Topnavbar from "../../Layouts/Topnavbar";
import { IconGraph, IconUser, IconWallet } from "@tabler/icons-react";
import { useState, useEffect } from "react";
import { message } from "antd";
import { Userauthcontexthooks } from "../../Hooks/Userauthcontexthooks";
import { Get_Dashboard_Details_dist, Get_User_Details } from "../../apicall";









const Dashboarddist = ({ Headername }) => {

    const { user } = Userauthcontexthooks();
    const [dashboardDetails, setDashboardDetails] = useState(null);
    const [dahboardloading, setdashboardloading] = useState(true);
    const [selfProfiledetails, setProfiledetails] = useState(''); // Self profile 

    useEffect(() => {
        const fetchDashboardDetails = async () => {
            try {
                const data = await Get_Dashboard_Details_dist();

                if (data.success) {
                    //console.log(data);
                    setDashboardDetails(data?.dashboard)
                }

            } catch (error) {

                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setdashboardloading(false);
            }
        }
        const GetUserprofile = async () => {
            try {
                const data = await Get_User_Details();
                if (data.success) {
                    // console.log(data);
                    setProfiledetails(data?.user)
                }
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            }
        }
        if (user) {
            fetchDashboardDetails();
            GetUserprofile()
        }
    }, [user])
    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Dashboard</Title>
                <Text size="xs">You can view your business performance.</Text>
            </Container>
            <Container size="lg" mt="lg">
                <Title order={3} c={'blue'} mb={'xs'}>Summary:</Title>
                <Grid>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'green'}
                                        variant="light"
                                    >
                                        <IconWallet size={28} />
                                    </ThemeIcon>

                                    {/* <ActionIcon
                                    radius="xl"
                                    variant="light"
                                    color={service.color}
                                >
                                    <IconArrowRight size={18} />
                                </ActionIcon> */}
                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.summary?.availableBalance || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Avilabel Balance
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'green'}
                                        variant="light"
                                    >
                                        <IconGraph size={28} />
                                    </ThemeIcon>

                                    {/* <ActionIcon
                                    radius="xl"
                                    variant="light"
                                    color={service.color}
                                >
                                    <IconArrowRight size={18} />
                                </ActionIcon> */}
                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    {dashboardDetails?.summary?.todayTransactionCount || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Today Transaction Count
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'green'}
                                        variant="light"
                                    >
                                        <IconGraph size={28} />
                                    </ThemeIcon>

                                    {/* <ActionIcon
                                    radius="xl"
                                    variant="light"
                                    color={service.color}
                                >
                                    <IconArrowRight size={18} />
                                </ActionIcon> */}
                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.summary?.todayTransactionVolume || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Today Transaction Volume
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>

                </Grid>
            </Container>
            <Container size="lg" mt="lg">
                <Title order={3} c={'blue'} mb={'xs'}>Balances:</Title>
                <Grid>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'green'}
                                        variant="light"
                                    >
                                        <IconWallet size={28} />
                                    </ThemeIcon>

                                    {/* <ActionIcon
                                    radius="xl"
                                    variant="light"
                                    color={service.color}
                                >
                                    <IconArrowRight size={18} />
                                </ActionIcon> */}
                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.balances?.mainBalance || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Main Balance
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'red'}
                                        variant="light"
                                    >
                                        <IconWallet size={28} />
                                    </ThemeIcon>

                                    {/* <ActionIcon
                                    radius="xl"
                                    variant="light"
                                    color={service.color}
                                >
                                    <IconArrowRight size={18} />
                                </ActionIcon> */}
                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.balances?.advanceCredit || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Advance Credit
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    {
                        selfProfiledetails?.acc_type === 'Distributor' ?
                            <>
                                <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                                    <Skeleton visible={dahboardloading} height={150}>
                                        <Paper radius="xs"
                                            p="lg"
                                            shadow="sm"
                                            withBorder
                                            style={{
                                                cursor: "pointer",
                                                transition: "all .25s ease",
                                                height: 150,
                                            }}>
                                            <Group justify="space-between">
                                                <ThemeIcon
                                                    radius="xl"
                                                    size={54}
                                                    color={'red'}
                                                    variant="light"
                                                >
                                                    <IconWallet size={28} />
                                                </ThemeIcon>
                                            </Group>

                                            <Text fw={700} mt="lg" size="lg">
                                                ₹{dashboardDetails?.balances?.masterDistributorCredit || 0}
                                            </Text>

                                            <Text c="dimmed" size="xs" mt={2}>
                                                Master Credit
                                            </Text>
                                        </Paper>
                                    </Skeleton>
                                </Grid.Col>
                                <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                                    <Skeleton visible={dahboardloading} height={150}>
                                        <Paper radius="xs"
                                            p="lg"
                                            shadow="sm"
                                            withBorder
                                            style={{
                                                cursor: "pointer",
                                                transition: "all .25s ease",
                                                height: 150,
                                            }}>
                                            <Group justify="space-between">
                                                <ThemeIcon
                                                    radius="xl"
                                                    size={54}
                                                    color={'red'}
                                                    variant="light"
                                                >
                                                    <IconWallet size={28} />
                                                </ThemeIcon>


                                            </Group>

                                            <Text fw={700} mt="lg" size="lg">
                                                ₹{Math.abs(Number(dashboardDetails?.balances?.distributorCredit || 0)).toFixed(2)}
                                            </Text>

                                            <Text c="dimmed" size="xs" mt={2}>
                                                Retailer Debit
                                            </Text>
                                        </Paper>
                                    </Skeleton>
                                </Grid.Col>
                            </>
                            :
                            (
                                <>
                                    <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                                        <Skeleton visible={dahboardloading} height={150}>
                                            <Paper radius="xs"
                                                p="lg"
                                                shadow="sm"
                                                withBorder
                                                style={{
                                                    cursor: "pointer",
                                                    transition: "all .25s ease",
                                                    height: 150,
                                                }}>
                                                <Group justify="space-between">
                                                    <ThemeIcon
                                                        radius="xl"
                                                        size={54}
                                                        color={'red'}
                                                        variant="light"
                                                    >
                                                        <IconWallet size={28} />
                                                    </ThemeIcon>


                                                </Group>

                                                <Text fw={700} mt="lg" size="lg">
                                                    {/* ₹{dashboardDetails?.balances?.masterDistributorCredit || 0} */}
                                                    ₹{Math.abs(Number(dashboardDetails?.balances?.masterDistributorCredit || 0)).toFixed(2)}
                                                </Text>

                                                <Text c="dimmed" size="xs" mt={2}>
                                                    Retailer Debit
                                                </Text>
                                            </Paper>
                                        </Skeleton>
                                    </Grid.Col>
                                    <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                                        <Skeleton visible={dahboardloading} height={150}>
                                            <Paper radius="xs"
                                                p="lg"
                                                shadow="sm"
                                                withBorder
                                                style={{
                                                    cursor: "pointer",
                                                    transition: "all .25s ease",
                                                    height: 150,
                                                }}>
                                                <Group justify="space-between">
                                                    <ThemeIcon
                                                        radius="xl"
                                                        size={54}
                                                        color={'red'}
                                                        variant="light"
                                                    >
                                                        <IconWallet size={28} />
                                                    </ThemeIcon>
                                                </Group>

                                                <Text fw={700} mt="lg" size="lg">
                                                    {/* ₹{dashboardDetails?.balances?.masterDistributorCredit || 0} */}
                                                    ₹{Math.abs(Number(dashboardDetails?.balances?.masterDistributorCredit || 0)).toFixed(2)}
                                                </Text>

                                                <Text c="dimmed" size="xs" mt={2}>
                                                    Distributor Debit
                                                </Text>
                                            </Paper>
                                        </Skeleton>
                                    </Grid.Col>

                                </>
                            )
                    }

                </Grid>
            </Container>
            <Container size="lg" mt="lg" mb={'sm'}>
                <Title order={3} c={'blue'} mb={'xs'}>Users:</Title>
                <Grid>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'lime'}
                                        variant="light"
                                    >
                                        <IconUser size={28} />
                                    </ThemeIcon>

                                    {/* <ActionIcon
                                    radius="xl"
                                    variant="light"
                                    color={service.color}
                                >
                                    <IconArrowRight size={18} />
                                </ActionIcon> */}
                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    {dashboardDetails?.CRM?.retailerCount || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Retailer Count
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    {
                        selfProfiledetails?.acc_type === 'Master Distributor' && (<Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                            <Skeleton visible={dahboardloading} height={150}>
                                <Paper radius="xs"
                                    p="lg"
                                    shadow="sm"
                                    withBorder
                                    style={{
                                        cursor: "pointer",
                                        transition: "all .25s ease",
                                        height: 150,
                                    }}>
                                    <Group justify="space-between">
                                        <ThemeIcon
                                            radius="xl"
                                            size={54}
                                            color={'lime'}
                                            variant="light"
                                        >
                                            <IconUser size={28} />
                                        </ThemeIcon>

                                        {/* <ActionIcon
                                        radius="xl"
                                        variant="light"
                                        color={service.color}
                                    >
                                        <IconArrowRight size={18} />
                                    </ActionIcon> */}
                                    </Group>

                                    <Text fw={700} mt="lg" size="lg">
                                        {dashboardDetails?.CRM?.distributorCount || 0}
                                    </Text>

                                    <Text c="dimmed" size="xs" mt={2}>
                                        Distributor Count
                                    </Text>
                                </Paper>
                            </Skeleton>
                        </Grid.Col>)
                    }



                </Grid>
            </Container>
            <Container size="lg" mt="lg" mb={'sm'}>
                <Title order={3} c={'blue'} mb={'xs'}>Turnover:</Title>
                <Grid>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'violet'}
                                        variant="light"
                                    >
                                        <IconGraph size={28} />
                                    </ThemeIcon>

                                    {/* <ActionIcon
                                    radius="xl"
                                    variant="light"
                                    color={service.color}
                                >
                                    <IconArrowRight size={18} />
                                </ActionIcon> */}
                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.turnover?.today || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Today Turnover
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'violet'}
                                        variant="light"
                                    >
                                        <IconGraph size={28} />
                                    </ThemeIcon>

                                    {/* <ActionIcon
                                    radius="xl"
                                    variant="light"
                                    color={service.color}
                                >
                                    <IconArrowRight size={18} />
                                </ActionIcon> */}
                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.turnover?.weekly || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Weekly Turnover
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'violet'}
                                        variant="light"
                                    >
                                        <IconGraph size={28} />
                                    </ThemeIcon>

                                    {/* <ActionIcon
                                    radius="xl"
                                    variant="light"
                                    color={service.color}
                                >
                                    <IconArrowRight size={18} />
                                </ActionIcon> */}
                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.turnover?.monthly || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Monthly Turnover
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>

                </Grid>
            </Container>
        </>
    )
}
export default Dashboarddist;